import React, { useState, useEffect, useRef } from "react";
import img from "../../thirdAssets/Images/bestOfBestImage.jpg";
import highEquipmentLogo from "../../thirdAssets/Images/high-equipments-logo.png"
import { Flex, Progress } from 'antd';

const HighEquipments = (props) => {
    const { selectedLanguage, secondClass } = props
    const [endodonticPercent, setEndodonticPercent] = useState(0);
    const [operatoryPercent, setOperatoryPercent] = useState(0);
    const [microscopesPercent, setMicroscopesPercent] = useState(0);
    const [lightsPercent, setLightsPercent] = useState(0);
    const [inView, setInView] = useState(false);
    const progressRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setInView(true);
                } else {
                    setInView(false);
                }
            });
        }, { threshold: 0.1 });

        if (progressRef.current) {
            observer.observe(progressRef.current);
        }

        return () => {
            if (progressRef.current) {
                observer.unobserve(progressRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (inView) {
            const endodonticTimer = setInterval(() => {
                setEndodonticPercent((prevPercent) => {
                    if (prevPercent >= 86) {
                        clearInterval(endodonticTimer);
                        return 86;
                    }
                    return prevPercent + 1;
                });
            }, 50);

            const operatoryTimer = setInterval(() => {
                setOperatoryPercent((prevPercent) => {
                    if (prevPercent >= 90) {
                        clearInterval(operatoryTimer);
                        return 90;
                    }
                    return prevPercent + 1;
                });
            }, 50);

            const microscopesTimer = setInterval(() => {
                setMicroscopesPercent((prevPercent) => {
                    if (prevPercent >= 87) {
                        clearInterval(microscopesTimer);
                        return 87;
                    }
                    return prevPercent + 1;
                });
            }, 50);

            const lightsTimer = setInterval(() => {
                setLightsPercent((prevPercent) => {
                    if (prevPercent >= 90) {
                        clearInterval(lightsTimer);
                        return 90;
                    }
                    return prevPercent + 1;
                });
            }, 50);

            return () => {
                clearInterval(endodonticTimer);
                clearInterval(operatoryTimer);
                clearInterval(microscopesTimer);
                clearInterval(lightsTimer);
            };
        }
    }, [inView]);

    return (
        <div className={`high-equipments ${secondClass}`} ref={progressRef}>
            <div className="high-equipment-img-div">
                <div className="high-equipment-img">
                    <img src={img} alt="" />
                    <div className="high-equipment-img-bottom-circle">
                        <img src={highEquipmentLogo} alt="" />
                    </div>
                </div>
            </div>
            <div className="third-design-home-about-left-div high-equipments-right-div">
                <h2 data-aos="fade-right"
                    data-aos-easing="ease-out-cubic"
                    data-aos-delay="100"
                    data-aos-offset="0"
                    data-aos-duration="1500">{selectedLanguage?.txt_best_of_the_best}</h2>
                <h1>{selectedLanguage?.txt_high_end_equipments}</h1>
                <p>{selectedLanguage?.txt_it_is_important_to_take}
                </p>
                <Flex gap="small" vertical>
                    <h2 className="progress-text">{selectedLanguage?.txt_endodontic_equipment}</h2>
                    <Progress strokeColor='#01D3BE' percent={endodonticPercent} />
                    <h2 className="progress-text">{selectedLanguage?.txt_operatory_cabinetry}</h2>
                    <Progress strokeColor='#01D3BE' percent={operatoryPercent} />
                    <h2 className="progress-text">{selectedLanguage?.txt_surgical_microscopes}</h2>
                    <Progress strokeColor='#01D3BE' percent={microscopesPercent} />
                    <h2 className="progress-text">{selectedLanguage?.txt_dental_operatory_lights}</h2>
                    <Progress strokeColor='#01D3BE' percent={lightsPercent} />
                </Flex>
                <button className="third-design-learn-more-btn">{selectedLanguage?.txt_learn_more}</button>
            </div>
        </div>
    );
};

export default HighEquipments;
